import { render } from "./OsStatusSelect.vue?vue&type=template&id=63054efc"
import script from "./OsStatusSelect.vue?vue&type=script&lang=js"
export * from "./OsStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__